import React, { useState,useEffect } from "react";
import Footer from "../../components/footer/Footer.js";
import TopButton from "../../components/topButton/TopButton.js";
import "./Services.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import {useNavigate} from 'react-router-dom'
import Navigationbar from "../../components/header/Navigationbar.jsx";
import {Col, Container, Row} from "react-bootstrap"
import Carousel from "react-bootstrap/Carousel";
import Zoom from 'react-reveal/Zoom';
import WhatsAppCard from "../contact/WhatsAppCard.jsx";

const Services = (props) => {
  const theme = props.theme;
  const [isExpanded, setIsExpanded] = useState(false);
  const [isExpanded1, setIsExpanded1] = useState(false);
  const [isExpanded2, setIsExpanded2] = useState(false);
  const [isExpanded3, setIsExpanded3] = useState(false);
  const [isExpanded4, setIsExpanded4] = useState(false);
  const handleDivClick = () => {
    setIsExpanded(!isExpanded);
  };
  const handleDivClick1 = () => {
    setIsExpanded1(!isExpanded1);
  };
  const handleDivClick2 = () => {
    setIsExpanded2(!isExpanded2);
  };
  const handleDivClick3 = () => {
    setIsExpanded3(!isExpanded3);
  };
  const handleDivClick4 = () => {
    setIsExpanded4(!isExpanded4);
  };
  const Navigate= useNavigate()
  const [isScrollingUp, setIsScrollingUp] = useState(true);
  const [animationShown, setAnimationShown] = useState(false);

  const handleScroll = (event) => {
    setIsScrollingUp(event.deltaY < 0);
  };

  const handleTouchMove = (event) => {
    setIsScrollingUp(event.deltaY < 0);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    if (isScrollingUp && !animationShown) {
      setAnimationShown(true);
    }

    window.addEventListener('wheel', handleScroll);
    window.addEventListener('touchmove', handleTouchMove);

    return () => {
      window.removeEventListener('wheel', handleScroll);
      window.removeEventListener('touchmove', handleTouchMove);
    };
  }, [isScrollingUp, animationShown]);
  return (
    <div className="educaton-main">
      <Navigationbar theme={theme} />
        <div>
          <div>
            <div className="basic-education1">
            <Container className="p-0 w-100" fluid  >
                <Col>
                <Carousel interval={2000} className="custom-carousel">
                  <Carousel.Item>
                    <img
                      className="d-block w-100"
                      src='/assets/images/img8.jpg'  
                      alt="First slide"
                    />
                    <Carousel.Caption >
                      <h1 style={{ color: 'black', fontWeight: 'bold' }}>Our Services</h1>
                    </Carousel.Caption> 
                  </Carousel.Item>
                  <Carousel.Item>
                    <img
                    style={{objectFit:'cover',objectPosition:'center'}}
                      className="d-block w-100"
                      src='/assets/images/service3.jpg'
                      alt="First slide"
                    />
                    <Carousel.Caption >
                      <h1 style={{ color: 'black', fontWeight: 'bold' }}>Our Services</h1>
                    </Carousel.Caption>
                  </Carousel.Item>
                  <Carousel.Item>
                    <img
                      className="d-block w-100"
                      // src={img3}
                      src="/assets/images/img7.jpg"
                      alt="First slide"
                    />
                    <Carousel.Caption >
                      <h1 style={{ color: 'black', fontWeight: 'bold' }} >Our Services</h1>
                    </Carousel.Caption>
                  </Carousel.Item>
                  <Carousel.Item>
                    <img
                      className="d-block w-100"
                      src='/assets/images/service5.jpg'
                      alt="First slide"
                    />
                    <Carousel.Caption >
                      <h1 style={{ color: 'black', fontWeight: 'bold' }}>Our Services</h1>
                    </Carousel.Caption>
                  </Carousel.Item>
                </Carousel>
                </Col>
            </Container>
              <div className='services-broking'>
                {isScrollingUp && animationShown ? (
                  <>                 
                    <div className='services-broking-text'>
                      <p className='services-broking-text-header'>BROKING</p>
                      <p className='services-broking-text-main'>Financial broking involves acting as a conduit between buyers and sellers in markets such as stocks, bonds, and commodities. Brokers provide expertise, advice, and access to these markets, aiding clients in making informed investment choices. They execute transactions, analyze market trends, and earn fees or commissions for their services. Evolving with technology, brokers blend traditional expertise with modern tools to navigate complex financial instruments, meeting diverse client needs in dynamic markets.</p>
                    </div>                  
                  </>
                ) : (
                  <Zoom>
                    <div className='services-broking-text'>
                      <p className='services-broking-text-header'>BROKING</p>
                      <p className='services-broking-text-main'>Financial broking involves acting as a conduit between buyers and sellers in markets such as stocks, bonds, and commodities. Brokers provide expertise, advice, and access to these markets, aiding clients in making informed investment choices. They execute transactions, analyze market trends, and earn fees or commissions for their services. Evolving with technology, brokers blend traditional expertise with modern tools to navigate complex financial instruments, meeting diverse client needs in dynamic markets.</p>
                    </div>
                  </Zoom>
                )}
                {isScrollingUp && animationShown ? (
                <>   
                  <div className='services-broking-card'>
                    <div className={`experience2 ${isExpanded ? "experience2grow" : ""}`} onMouseEnter={handleDivClick} onMouseLeave={handleDivClick} >
                      <div className={`circle ${isExpanded ? "expanded" : ""}`}></div>
                        <button className={`experience3 ${isExpanded ? "experience3grow" : ""}`} onClick={()=>Navigate('/services/broking')}>BROKING</button>
                      </div>
                  </div>               
                </>
                ) : (
                <Zoom>
                  <div className='services-broking-card'>
                    <div className={`experience2 ${isExpanded ? "experience2grow" : ""}`} onMouseEnter={handleDivClick} onMouseLeave={handleDivClick} >
                      <div className={`circle ${isExpanded ? "expanded" : ""}`}></div>
                      <button className={`experience3 ${isExpanded ? "experience3grow" : ""}`} onClick={()=>Navigate('/services/broking')}>BROKING</button>
                    </div>
                  </div>
                </Zoom>
              )}
              </div>
              <div className='services-insurance'>
                {isScrollingUp && animationShown ? (
                  <>               
                    <div className='services-insurance-card'>
                      <div className={`experience2 ${isExpanded1 ? "experience2grow" : ""}`} onMouseEnter={handleDivClick1} onMouseLeave={handleDivClick1}>
                        <div className={`circle ${isExpanded1 ? "expanded" : ""}`}></div>
                        <button className={`experience3 ${isExpanded1 ? "experience3grow" : ""}`} onClick={()=>Navigate('/services/insurance')}>INSURANCE BROKING</button>
                      </div>
                    </div>          
                  </>
                ) : (
                  <Zoom>
                    <div className='services-insurance-card'>
                      <div className={`experience2 ${isExpanded1 ? "experience2grow" : ""}`} onMouseEnter={handleDivClick1} onMouseLeave={handleDivClick1}>
                        <div className={`circle ${isExpanded1 ? "expanded" : ""}`}></div>
                        <button className={`experience3 ${isExpanded1 ? "experience3grow" : ""}`} onClick={()=>Navigate('/services/insurance')}>INSURANCE BROKING</button>
                      </div>
                    </div>
                  </Zoom>
                )}
                {isScrollingUp && animationShown ? (
                  <>   
                    <div className='services-insurance-text'>
                      <p className='services-insurance-text-header'>INSURANCE BROKING</p>
                      <p className='services-insurance-text-main'>Insurance broking involves intermediating between insurance companies and clients. Brokers assess client needs, offer advice on insurance coverage, and negotiate policies with insurers. They provide expertise, helping clients understand various options, terms, and costs. Brokers work to secure appropriate coverage and assist in claims processes, earning commissions from insurers while ensuring clients' insurance needs are met effectively.</p>
                    </div>                   
                  </>
                ) : (
                  <Zoom>
                    <div className='services-insurance-text'>
                      <p className='services-insurance-text-header'>INSURANCE BROKING</p>
                      <p className='services-insurance-text-main'>Insurance broking involves intermediating between insurance companies and clients. Brokers assess client needs, offer advice on insurance coverage, and negotiate policies with insurers. They provide expertise, helping clients understand various options, terms, and costs. Brokers work to secure appropriate coverage and assist in claims processes, earning commissions from insurers while ensuring clients' insurance needs are met effectively.</p>
                    </div>
                  </Zoom>
                )}
              </div>
              <div className='services-distribution'>
                {isScrollingUp && animationShown ? (
                  <>       
                    <div className='services-distribution-text'>
                      <p className='services-distribution-text-header'>DISTRIBUTION</p>
                      <p className='services-distribution-text-main'>Financial distribution refers to the process of disseminating financial products and services to consumers through various channels. This includes banks, online platforms, intermediaries, and insurance agents. Distribution strategies aim to reach a wide audience, offering diverse financial solutions such as loans, investments, and insurance. Effective distribution ensures accessibility, enabling individuals and businesses to access the financial products best suited to their needs through different avenues.</p>
                    </div>
                  </>
                ) : (
                  <Zoom>
                    <div className='services-distribution-text'>
                      <p className='services-distribution-text-header'>DISTRIBUTION</p>
                      <p className='services-distribution-text-main'>Financial distribution refers to the process of disseminating financial products and services to consumers through various channels. This includes banks, online platforms, intermediaries, and insurance agents. Distribution strategies aim to reach a wide audience, offering diverse financial solutions such as loans, investments, and insurance. Effective distribution ensures accessibility, enabling individuals and businesses to access the financial products best suited to their needs through different avenues.</p>
                    </div>
                  </Zoom>
                )}
                {isScrollingUp && animationShown ? (
                <> 
                  <div className='services-distribution-card'>
                    <div onMouseEnter={handleDivClick2} onMouseLeave={handleDivClick2} className="experience2" >
                      <div className={`circle ${isExpanded2 ? "expanded" : ""}`}></div>
                      <Link to="/services/distribution" className={`experience3 ${isExpanded2 ? "experience3grow" : ""}`}>DISTRIBUTION</Link>
                    </div>
                  </div>
                  </>
                ) : (
                <Zoom>
                  <div className='services-distribution-card'>
                    <div onMouseEnter={handleDivClick2} onMouseLeave={handleDivClick2} className="experience2" >
                      <div className={`circle ${isExpanded2 ? "expanded" : ""}`}></div>
                        <Link to="/services/distribution" className={`experience3 ${isExpanded2 ? "experience3grow" : ""}`}>DISTRIBUTION</Link>
                      </div>
                  </div>
                </Zoom>
              )}
              </div>
              <div className='services-advistory'>
                {isScrollingUp && animationShown ? (
                  <>
                    <div className='services-advistory-card'>
                      <div onMouseEnter={handleDivClick3} onMouseLeave={handleDivClick3} className="experience2">
                        <div className={`circle4 ${isExpanded3 ? "expanded4" : ""}`}></div>
                        <Link to="/services/advistory" className={`experience3 ${isExpanded3 ? "experience3grow" : ""}`}>ADVISORY</Link>
                      </div>
                    </div>
                  </>
                ) : (
                  <Zoom>
                    <div className='services-advistory-card'>
                    <div onMouseEnter={handleDivClick3} onMouseLeave={handleDivClick3} className="experience2">
                      <div className={`circle4 ${isExpanded3 ? "expanded4" : ""}`}></div>
                      <Link to="/services/advistory" className={`experience3 ${isExpanded3 ? "experience3grow" : ""}`}>ADVISORY</Link>
                    </div>
                    </div>
                  </Zoom>
                )}
                {isScrollingUp && animationShown ? (
                  <> 
                    <div className='services-advistory-text'>
                      <p className='services-advistory-text-header'>ADVISORY</p>
                      <p className='services-advistory-text-main'>Financial advisory involves offering guidance and recommendations on financial matters to individuals, businesses, or institutions. Advisors assess clients' financial situations, goals, and risk tolerance to provide personalized strategies for investments, retirement planning, wealth management, and more. They offer insights, expertise, and ongoing support, aiming to optimize financial decisions aligned with clients' objectives and circumstances.</p>
                    </div>
                  </>
                ) : (
                  <Zoom>
                    <div className='services-advistory-text'>
                      <p className='services-advistory-text-header'>ADVISORY</p>
                      <p className='services-advistory-text-main'>Financial advisory involves offering guidance and recommendations on financial matters to individuals, businesses, or institutions. Advisors assess clients' financial situations, goals, and risk tolerance to provide personalized strategies for investments, retirement planning, wealth management, and more. They offer insights, expertise, and ongoing support, aiming to optimize financial decisions aligned with clients' objectives and circumstances.</p>
                    </div>
                </Zoom>
                )}
              </div>
              <div className='services-financing'>
                {isScrollingUp && animationShown ? (
                  <>
                    <div className='services-financing-text'>
                      <p className='services-financing-text-header'>FINANCING</p>
                      <p className='services-financing-text-main'>Financing involves providing funds or capital to individuals, businesses, or projects. It encompasses various methods like loans, credit, or investment to facilitate purchases, operations, or expansions. Lenders or investors assess creditworthiness, terms, and risks before providing capital. Financing enables endeavors to grow, acquire assets, or manage cash flow, playing a crucial role in sustaining and expanding businesses or personal endeavors.</p>
                    </div>
                  </>
                ) : (
                  <Zoom>
                    <div className='services-financing-text'>
                      <p className='services-financing-text-header'>FINANCING</p>
                      <p className='services-financing-text-main'>Financing involves providing funds or capital to individuals, businesses, or projects. It encompasses various methods like loans, credit, or investment to facilitate purchases, operations, or expansions. Lenders or investors assess creditworthiness, terms, and risks before providing capital. Financing enables endeavors to grow, acquire assets, or manage cash flow, playing a crucial role in sustaining and expanding businesses or personal endeavors.</p>
                    </div>
                  </Zoom>
                )}
                {isScrollingUp && animationShown ? (
                  <>
                    <div className='services-financing-card'>
                      <div onMouseEnter={handleDivClick4} onMouseLeave={handleDivClick4} className="experience2">
                        <div className={`circle5 ${isExpanded4 ? "expanded5" : ""}`}></div>
                        <Link to="/services/financing" className={`experience3 ${isExpanded4 ? "experience3grow" : ""}`}>FINANCING</Link>
                        </div>
                    </div>
                  </>
                ) : (
                  <Zoom>
                    <div className='services-financing-card'>
                      <div onMouseEnter={handleDivClick4} onMouseLeave={handleDivClick4} className="experience2">
                        <div className={`circle5 ${isExpanded4 ? "expanded5" : ""}`}></div>
                        <Link to="/services/financing" className={`experience3 ${isExpanded4 ? "experience3grow" : ""}`}>FINANCING</Link>
                      </div>
                    </div>
                  </Zoom>
                )}
              </div>
            </div>
            <Footer theme={props.theme} onToggle={props.onToggle} />
            <TopButton theme={props.theme} />
          </div>
        </div>
        <WhatsAppCard/>
    </div>
  );
};

export default Services;